
import { Link } from 'react-router-dom';
import '../../assets/css/wishlist.css';
import Breadcrumb from '../../Component/Layout/Breadcrumb';

const products = [
  'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Afroz/66A_RIX81.jpg',
  'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Afroz/6734B_RIX73.jpg',
  'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Afroz/6735B_RIX53.jpg',
  'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Afroz/6735B_RIX73.jpg',
  'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Affinity_reversible/LIME_LIME.jpg',
];

function Wishlist() {
  const handleShow = (index) => {
    console.log(`Product ${index + 1} clicked.`);
  };

  return (
    <>
      <Breadcrumb />
      <section className="wishlist mt-2">
        <div className="container">
          <div className="row mb-2">
            <div className="col-12">
              <div className="Filterbg">
                <h4
                  className="text-gray-500 text-sm pt-2 font-normal mt-2"
                  style={{ fontSize: '19px' }}
                >
                  Wishlist
                </h4>
              </div>
            </div>
          </div>

          <div className="row row-cols-2 row-cols-md-3 row-cols-xl-5 g-3">
            {products.map((url, index) => (
              <div className="col" key={index}>
                <div className="box">
                  <div className="boximages" onClick={() => handleShow(index)}>
                    <img
                      src={url}
                      alt={`Product ${index + 1}`}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <div className="box-title d-flex justify-content-between align-items-center">
                    <p className="mb-0">
                      AHVAZ <span className="d-block">G137 NE</span>
                    </p>
                    <Link to="#" className="text-yellow" title="Remove from wishlist">
                      <i className="bi bi-trash"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Wishlist;
